import { useEffect, useMemo, useState } from 'react';

// custom hook to use persistence state declared here
export default function usePersistentState<T>(initialValue: T, id: string) {
  // fetching state value from local storage here
  const storageInitialValue = useMemo(() => {
    const storageValueStr = localStorage.getItem('state:' + id);

    if (storageValueStr) {
      return JSON.parse(storageValueStr);
    }

    return initialValue;
  }, [id, initialValue]);

  // integration of react hooks here
  const [state, setState] = useState(storageInitialValue);

  // setting the state value into the local storage here
  useEffect(() => {
    const stateStr = JSON.stringify(state);

    localStorage.setItem('state:' + id, stateStr);
  }, [state, id]);

  return [state, setState];
}
